
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.75 21.75h22.5M6 11.25H3a.75.75 0 0 0-.75.75v9.75h4.5V12a.75.75 0 0 0-.75-.75Zm7.5-9h-3a.75.75 0 0 0-.75.75v18.75h4.5V3a.75.75 0 0 0-.75-.75Zm7.5 4.5h-3a.75.75 0 0 0-.75.75v14.25h4.5V7.5a.75.75 0 0 0-.75-.75Z","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    